import React, {useState } from 'react';
import ReactTable from "react-table";
import LabSelect from "../components/LabSelect.jsx";
import DashboardDetail from "../components/DashboardDetail.jsx";
import moment from 'moment';
import Pikaday from "../components/Pikaday.jsx";

const columns = [
    {Header: "Lab", accessor: 'summarylabid'},
    {Header: "Acct", accessor: 'summaryacct',},
    {
        Header: "Date", Cell: ({original}) => {
            return moment(original.summarydate).format('YYYY-MM-DD');
        }
    },
    {Header: 'Number of orders', accessor: 'summarynumorders'},
    {Header: 'Number of views', accessor: 'summarynumviews'}
];

const initialInputs = {
    lab: "",
    startdate: moment(),
    enddate: moment(),
    acct: "",
};

export default (props) => {
    const [inputs, setInputs] = useState(initialInputs);
    const [loading, setLoading] = useState(false);
    const [dashboardData, setDashboardData] = useState([]);
    const handleChange = e => {
        setInputs({
            ...inputs,
            [e.target.name]: e.target.value
        })
    };

    const handleSubmit = async e => {
        e.preventDefault();
        setLoading(true);
        try {
            const resp = await fetch(`/webservice/dashboard?lab=${inputs.lab}&startdate=${inputs.startdate.format('YYYYMMDD')}&acct=${inputs.acct}&enddate=${inputs.enddate.format('YYYYMMDD')}`);
            const json = await resp.json();
            setDashboardData(json);
        } catch(e) {
            setDashboardData([]);
            console.log("Failed to get dashboard");
        } finally {
            setLoading(false);
        }


    };
    console.log(inputs);
    return (
        <div className="col-xs-12 text-left" style={{marginTop: '-5%'}}>
            <div className="page-header">Dashboard</div>
            <form method="get" onSubmit={handleSubmit}>
                <div className="user-form">
                    <div className="row">
                        <div className="col-xs-6">
                            <div className="form-group">
                                <label>Lab:</label>
                                <LabSelect
                                    onChange={handleChange}
                                    value={inputs.lab}
                                />
                            </div>
                        </div>
                        <div className="col-xs-3">
                            <div className="form-group">
                                <label>Start Date:</label>
                                <Pikaday
                                    id="date"
                                    type="text"
                                    name="startdate"
                                    className="form-control"
                                    onChange={date => {
                                        setInputs({...inputs, startdate: date})
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-xs-3">
                            <div className="form-group">
                                <label>End Date:</label>
                                <Pikaday
                                    id="enddate"
                                    name="endDate"
                                    className="form-control"
                                    onChange={date => {
                                        setInputs({...inputs, enddate: date})
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-xs-12">
                            <div className="form-group">
                                <button id="submit" className="btn btn-positive">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div className="user-form">
                <ReactTable
                    columns={columns}
                    data={dashboardData}
                    loading={loading}
                    SubComponent={row => <DashboardDetail {...row} />}
                />
            </div>
        </div>
    )
}
